// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"87":"assets/css/vue_common","196":"assets/css/app","357":"assets/css/bootstrap.min","458":"assets/css/jquery.dataTables","725":"assets/css/colorblind","926":"assets/css/cdash"}[chunkId] + ".css";
};